export const HIDE_DETAILS = 'Hide details';
export const SHOW_DETAILS = 'Show details';
